import React, { useEffect, useState } from 'react';
import "./stylesheet/Navbar.css";
import "./stylesheet/mobilesheet/NavbarM.css";
import { NavLink } from 'react-router-dom';
import Button from './button';



const Navbar = () => {
    const [timeOut,settimeOut] =useState(0);



const [Switch,setSwitch]=useState(false)
useEffect(
    
        ()=>{
            setTimeout(()=>{
          setSwitch(false)
          console.log("hello");
           },4000)
          
          
        
    },[timeOut])
    
    const toggle=(e)=>{
 if(Switch){
 
    setSwitch(false);
 }else{
  
    setSwitch(true);
    settimeOut(timeOut+1)
 }
    }
    

    
  return (
    
    <>
    <header><div className="navbar">
    <div className="image">
       
    </div>
    <div className="menu">
    <ul>
        <li className="box">
            <NavLink to="/" >Home</NavLink>
        </li>
        <li className="box">
            <NavLink to="/about" >About</NavLink>
        </li>
        <li className="box">
            <NavLink to="/portfolio" > Portfolio </NavLink>
        </li>
    </ul>


    </div>
    <div className="con-btn">
 <div className="button">
<Button link={"umangsahu359@gmail.com"} title={"Contact Me"} subtext={""}/>
 </div>

        <div className={Switch?"burger burgertoggle":"burger"} onClick={toggle} >
            <div className="lines"></div>
            <div className="line"></div>
            <div className="lines"></div>
        </div>
<div className={Switch?"tooltip":"tooltiptoggle"} >

<ul >
        <li className="box">
            <NavLink to="/" >Home</NavLink>
        </li>
        <li className="box">
            <NavLink to="/about" >About</NavLink>
        </li>
        <li className="box">
            <NavLink to="/portfolio" > Portfolio </NavLink>
        </li>
    </ul>
    <Button link={"hello world!"} title={"Contact Me"} subtext={""}/>
</div>
    </div>
   
</div></header>



    </>
  )
}
export default Navbar